<template>
  <div>
    <div id="content" class="content" style="margin-left:0px;">
      <h1 class="page-header" style="text-align:left">
        服务商管理
        <small>/&nbsp;服务商列表</small>
      </h1>

      <div
        id="page-container"
        class="in page-sidebar-fixed page-header-fixed"
        style="padding-top:0px;"
      >
        <!-- begin #content -->
        <div
          id="content"
          class="content"
          style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
        >
          <!-- begin breadcrumb -->

          <div class="row">
            <!-- begin col-10 -->
            <div class="col-lg-12">
              <!-- begin panel -->
              <div class="panel panel-inverse">
                <!-- begin panel-heading -->
                <div class="panel-heading">
                  <div class="panel-heading-btn">
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-default"
                      data-click="panel-expand"
                    >
                      <i class="fa fa-expand"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-success"
                      data-click="panel-reload"
                    >
                      <i class="fa fa-redo"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-warning"
                      data-click="panel-collapse"
                    >
                      <i class="fa fa-minus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-danger"
                      data-click="panel-remove"
                    >
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <h4 class="panel-title panelTitle">服务商列表</h4>
                </div>
                <!-- end panel-heading -->
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form

                    style="margin-top:16px;padding-left:15px;"
                  >
                    <fieldset>
                      <div class="form-group row m-b-15">
                        <label class="col-md-1 col-form-label">服务商名称</label>
                        <div class="col-md-2">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="服务商名称"
                            v-model="recomName"
                          >
                        </div>
                        <label class="col-md-1 col-form-label">分组名称</label>
                        <div class="col-md-2">
                          <v-selectpage :data="RecomOptions" key-field="groupId" show-field="groupName" v-model="groupId" placeholder="请选择分组名称" title=""></v-selectpage>
                        </div>
                        <label class="col-md-1 col-form-label">渠道号</label>
                        <div class="col-md-2">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="渠道号"
                            v-model="recom"
                          >
                        </div>
                        <div class="col-md-3"></div>
                        <label class="col-md-1 col-form-label LineSpacing">租户</label>
                        <div class="col-md-2 LineSpacing">
                          <el-select
                            v-model="form.lesseeId"
                            style="width:100%"
                            clearable
                            filterable
                            placeholder="请选择"
                            @change="(val) => {
                              $set(form, 'deptId', undefined)
                              $set(form, 'areaId', undefined)
                              departmentList = []
                              regionalList = []
                              if (val) {
                                getDeptList()
                                getAreaPageList()
                              }
                            }"
                          >
                            <el-option
                              v-for="item in lesseeList"
                              :key="item.id"
                              :label="item.lesseeName"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </div>
                        <label class="col-md-1 col-form-label LineSpacing">部门</label>
                        <div class="col-md-2 LineSpacing">
                          <el-select
                            v-model="form.deptId"
                            style="width:100%"
                            clearable
                            filterable
                            placeholder="请选择"
                            @change="(val) => {
                              $set(form, 'areaId', undefined)
                              getAreaPageList()
                            }"
                          >
                            <el-option
                              v-for="item in departmentList"
                              :key="item.id"
                              :label="item.deptName"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </div>
                        <label class="col-md-1 col-form-label LineSpacing">大区</label>
                        <div class="col-md-2 LineSpacing">
                          <el-select
                            v-model="form.areaId"
                            style="width:100%"
                            clearable
                            filterable
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in regionalList"
                              :key="item.id"
                              :label="item.areaName"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </div>
                        <div class="col-md-3 LineSpacing"></div>
                        <label class="col-md-1 col-form-label LineSpacing">状态</label>
                        <div class="col-md-2 LineSpacing">
                          <el-select
                            v-model="status"
                            style="width:100%"
                            clearable
                            filterable
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in statusList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </div>
                        <label class="col-md-1 col-form-label LineSpacing">创建时间</label>
                        <div class="col-md-3 LineSpacing">
                          <el-date-picker
                            style="width: 100%;"
                            v-model="value1"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                          </el-date-picker>
                        </div>
                        <div class="col-md-1 LineSpacing">
                          <a
                            class="btn btn-primary ButtonColor m-r-5"
                            @click="SearchClick()"
                            style="float:right;"
                          >查询</a>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                  <div style="text-align:right;margin-bottom:20px;">
                    <a
                      class="btn btn-primary ButtonColor m-r-5"
                      @click="ExportClick()"
                    >导出</a>
                    <a
                      v-if="this.hiddenbutton != 6533"
                      class="btn btn-primary ButtonColor"
                      @click="AddClick()"
                    >新增</a>
                  </div>
                  <el-table :data="UserManagementList" border style="width: 100%">
                    <el-table-column prop="ordernumber" label="序号"  width="60" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="recom" label="服务商渠道号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="recomName" label="服务商名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="groupName" label="分组名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="!isRecomRole" prop="domainUrl" label="域名地址" width="500" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态" align="center" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{scope.row.status === 0 ? '已禁用' : '启用中'}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="inputTime" label="创建时间" width="160" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="门店数量" width="120" align="center">
                      <template slot-scope="scope">
                        <span>{{scope.row.shopCount}}</span>
                        <el-button @click="SelectShops(scope.row)" type="text">
                          [查看设置]
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="设置" width="120" align="center">
                      <template slot-scope="scope">
                        <el-button type="text" @click="SettingShop(scope.row)">商城管理</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" align="center" fixed="right">
                      <template slot-scope="scope">
                        <a
                          class="btn btn-primary btn-sm ButtonColor"
                          data-toggle="modal"
                          @click="DetailClick(scope.row)"
                        >详情</a>
                        <a
                          class="btn btn-primary btn-sm ButtonColor"
                          data-toggle="modal"
                          @click="EditClick(scope.row)"
                        >编辑</a>
                        <a
                          v-if="hiddenbutton != 6533"
                          class="btn btn-warning btn-sm ButtonColor"
                          @click="DeleteClick(scope.row, scope.row.status === 0 ? '启用' : '禁用')"
                        >{{scope.row.status === 0 ? '启用' : '禁用'}}</a>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="PaginationStyle">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="pageindex"
                      :page-sizes="[10,20,50,100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                </div>
                <!-- end panel-body -->
              </div>
              <!-- end panel -->
            </div>
            <!-- end col-10 -->
          </div>
          <!-- end row -->
        </div>
        <!-- end #content -->
      </div>
      <el-dialog title :visible.sync="outerVisible" width="500px" >
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定{{statusName}}吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled = 'disabled'>确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>

      </el-dialog>
    </div>
  </div>

</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import dayjs from 'dayjs'
export default {
  name: "BrandManagement",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      EditDialog: 1,
      CurrentSelection: [],
      disabled: false,
      groupId: "",
      recomName:'',
      recom:'',
      UserManagementList: [],
      RecomOptions:[],
      hiddenbutton:"",
      isRecomRole: true,
      statusList: [
        {
          label: "全部",
          value: ''
        },
        {
          label: "启用中",
          value: 1
        },
        {
          label: "已禁用",
          value: 0
        }
      ],
      form: {},
      value1: [],
      lesseeList: [],
      departmentList: [],
      regionalList: [],
      status: '',
      statusName: ''
    };
  },
  mounted: function() {
    axios.post(`/user/roles/selectLoginRoles`)
      .then(res => {
        const roleList = (res.data || {}).data || []

        for (let role of roleList) {
          if (role.roleId === 5101) {
            this.isRecomRole = true
            return
          }
        }

        this.isRecomRole = false
      })
    if (this.$route.params && this.$route.params.searchContent) {
      this.groupId = this.$route.params.searchContent.groupId;
      this.recomName = this.$route.params.searchContent.recomName;
    }
    this.initdata();
    this.getRecomList();
    this.initDatabutton();
    this.getLesseeList()
  },
  watch:{
    pageNo: {
    　　handler(newName, oldName) {
            if(this.$route.params && this.$route.params.pageNo){

               this.pageNo = this.$route.params.pageNo
            }

       　　},
    　　immediate: true
    },
    pagesize:{
      　handler(newName, oldName) {
            if(this.$route.params && this.$route.params.pagesize){
               this.pageSize = this.$route.params.pagesize
            }

       　　},
    　　immediate: true
    }
  },
  computed: {
      pageNo:{
        set(val){
          if(val){

             this.pageindex = val
          }

        },
        get(){
          //console.log('我被调用了') //msg1获取值时触发

        },
      },
      pagesize:{
        set(val){
          if(val){
             this.pageSize = val
          }

        },
        get(){
          //console.log('我被调用了') //msg1获取值时触发

        }
      }
  },
  methods: {
    dayjs,
    getLesseeList () {
      let that = this
      axios.get('/distribution/lessee/getLesseeList').then(response => {
        if (response.data.code === 200) {
          that.lesseeList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getDeptList () {
      let that = this
      axios.get('/distribution/dept/getDeptList', {
        params: {
          lesseeId: that.form.lesseeId
        }
      }).then(response => {
        if (response.data.code === 200) {
          that.departmentList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getAreaPageList () {
      let that = this
      axios.get('/distribution/area/getAreaList', {
        params: {
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          areaType: 1,
          parentId: 0
        }
      }).then(response => {
        if (response.data.code === 200) {
          that.regionalList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    DetailClick (row) {
      let searchContent = {};
      searchContent.groupId = this.groupId;
      searchContent.recomName = this.recomName;
      this.$router.push({ path: "/distributordetail" });
      localStorage.setItem("goodlist", JSON.stringify({recomId:row.recomId,companyId:row.companyId,pageNo: this.pageindex,pageSize: this.pageSize,searchContent: searchContent}));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    EditClick(row) {
      this.$router.push({ path: "/editdistributor" });
      localStorage.setItem("goodlist", JSON.stringify({recomId:row.recomId,companyId:row.companyId,userId:row.userId,pageNo: this.pageindex,pageSize: this.pageSize}));
    },
    DeleteClick(item, statusName) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
      this.statusName = statusName
    },
    //显示 隐藏   按钮  数据
    initDatabutton() {
      let that = this;
      const options = {
        //  获取当前登录人角色
        url: "/distribution/B2cOrderInfoController/parsingUserTob",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.hiddenbutton = String(response.data.data.roleId);
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },

    //   服务商列表导出
/**/
 ExportClick() {
      let that = this;
      const options = {
        url: "/distribution/ExcelController/exportRecomInfo",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
         params: {
         groupId: that.groupId,
         recomName: that.recomName,
         recom: that.recom,
         lesseeId: that.form.lesseeId,
         deptId: that.form.deptId,
         areaId: that.form.areaId,
         status: that.status,
         startTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
         endTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[1]).format('YYYY-MM-DD HH:mm:ss') : undefined,
        }
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    ExportClickSecond() {
      let   that  = this
      const options = {
        url: "/distribution/ExcelController/exportRecomInfo",
       // url: "/distribution/ExcelController/exportOrderInfo",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {
         groupId:that.groupId,
         recomName:that.recomName,
          lesseeId: that.form.lesseeId,
          recom: that.recom,
          deptId: that.form.deptId,
          areaId: that.form.areaId,
          status: that.status,
          startTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
          endTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[1]).format('YYYY-MM-DD HH:mm:ss') : undefined,
        },
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          var filename = "服务商列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    AddClick() {
       this.$router.push({ path: "/adddistributor" });
       localStorage.setItem("goodlist", JSON.stringify({pageNo: this.pageindex,pageSize: this.pageSize}));
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      const options = {
        url: "/distribution/B2cRecomInfoController/updateRecomStatus",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: that.CurrentSelection.recomId,
          userId: that.CurrentSelection.userId,
          recomName: that.CurrentSelection.recomName,
          recomType: that.CurrentSelection.recomType,
          recom: that.CurrentSelection.recom,
          status: that.statusName === '禁用' ? 0 : 1
        })
      };
      axios(options).then(function(response) {
        that.disabled = false;
        that.outerVisible = false;
        that.initdata();
        if (response.data.code == 200) {
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
        } else {
            http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          that.disabled = false;
          that.outerVisible = false;
          http.handleHttpError(error, that);
        });
    },
    initdata() {
     let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/queryRecomInfoByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          areaId: that.form.areaId,
          startTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
          endTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[1]).format('YYYY-MM-DD HH:mm:ss') : undefined,
          groupId: that.groupId,
          recomName: that.recomName,
          recom: that.recom,
          status: that.status,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          for (var i in response.data.data.data) {
            response.data.data.data[i].ordernumber =
            Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
          }
          that.totalCount = response.data.data.totalCount;
          that.UserManagementList = response.data.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      }).catch((error) => {
        http.handleHttpError(error, that);
      });
    },
    // 获取分组
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cGroupInfoController/queryAllGroup",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.RecomOptions = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    // 查看门店
    SelectShops(item){
      this.$router.push({
        path: "/storelist",
        query: {recomId:item.recomId,companyId:item.companyId,recomName:item.recomName}
      });
    },
    // 商城设置
    SettingShop(row){
      let href = this.$router.resolve({
        path:'/mallsettingmenu',
        name:'MallSettingMenu',
        query: {
          recomId: row.recomId
        }
      });
      sessionStorage.setItem('recomName', row.recomName)
      sessionStorage.setItem('companyId', row.companyId)
      window.open(href.href, '_blank');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth{
  width:202px;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/DistributorList.vue